import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import interviewReducer from '@store/slices/interviewSlice';
import uiReducer from '@store/slices/uiSlice';
import legalReducer from '@store/slices/legalSlice';
import rootSaga from '@store/sagas';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    interview: interviewReducer,
    ui: uiReducer,
    legal: legalReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: {
        // Ignore FormData in submitAnswerRequest action
        // FormData is non-serializable but necessary for file uploads
        ignoredActions: ['persist/PERSIST', 'interview/submitAnswerRequest'],
        ignoredActionPaths: ['payload.formData'],
        ignoredPaths: ['interview.loading'],
      },
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;
